import React from 'react'
import {MuiThemeProvider} from '@material-ui/core/styles'
import {SnackbarProvider} from 'notistack'
import PageTrack from './components/PageTrack.js'
import ServiceWorkerProvider from './components/ServiceWorkerProvider.js'
import AuthProvider from './components/AuthProvider.js'
import UserProvider from './components/UserProvider.js'
import PrivateRoute from './components/PrivateRoute.js'
import RootRouteAuthenticatedAsync from './components/RootRouteAuthenticatedAsync.js'
import muiTheme from './muiTheme.js'

const snackbarProps = {
  maxSnack: 3,
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'center',
  },
}

const App = () => {
  return (
    <PageTrack>
      <ServiceWorkerProvider>
        <AuthProvider>
          <UserProvider>
            <MuiThemeProvider theme={muiTheme}>
              <SnackbarProvider {...snackbarProps}>
                <PrivateRoute default as={RootRouteAuthenticatedAsync} />
              </SnackbarProvider>
            </MuiThemeProvider>
          </UserProvider>
        </AuthProvider>
      </ServiceWorkerProvider>
    </PageTrack>
  )
}

export default App
